module.exports = __webpack_public_path__ + "static/media/RobotoMono-Italic.43f8f98b.ttf";


//////////////////
// WEBPACK FOOTER
// ./src/Assets/Fonts/RobotoMono-Italic.ttf
// module id = 114
// module chunks = 0